module.exports = __webpack_public_path__ + "static/img/img.1ac14335.png";